import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/services/[serviceCategory]/ServiceCategoryContent.tsx");
